const SITE_NAME = 'Shelendra Kumar Academy';

function upsertMeta(attr, key, content) {
  const selector = `meta[${attr}="${key}"]`;
  let meta = document.querySelector(selector);
  if (!meta) {
    meta = document.createElement('meta');
    meta.setAttribute(attr, key);
    document.head.appendChild(meta);
  }
  meta.setAttribute('content', content);
}

function upsertCanonical(url) {
  let link = document.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement('link');
    link.setAttribute('rel', 'canonical');
    document.head.appendChild(link);
  }
  link.setAttribute('href', url);
}

export function canonicalUrl(pathname) {
  const origin = window.location.origin;
  if (pathname === '/' || pathname === '') {
    return `${origin}/`;
  }
  if (pathname === '/web' || pathname === '/web/') {
    return `${origin}/web/`;
  }
  return `${origin}${pathname.replace(/\/$/, '')}`;
}

export function publicPath(routerPath) {
  const basename = process.env.PUBLIC_URL || '';
  if (!basename) {
    return routerPath;
  }
  if (routerPath === '/') {
    return `${basename}/`;
  }
  return `${basename}${routerPath}`;
}

export function setPageSeo({ title, description, path, type = 'website' }) {
  const fullTitle = title.includes(SITE_NAME) ? title : `${title} | ${SITE_NAME}`;
  const url = canonicalUrl(path || window.location.pathname);

  document.title = fullTitle;
  upsertMeta('name', 'description', description);
  upsertCanonical(url);
  upsertMeta('name', 'application-name', SITE_NAME);
  upsertMeta('property', 'og:type', type === 'article' ? 'article' : 'website');
  upsertMeta('property', 'og:site_name', SITE_NAME);
  upsertMeta('property', 'og:title', fullTitle);
  upsertMeta('property', 'og:description', description);
  upsertMeta('property', 'og:url', url);
  upsertMeta('name', 'twitter:card', 'summary');
  upsertMeta('name', 'twitter:title', fullTitle);
  upsertMeta('name', 'twitter:description', description);
}
